// import "./scss/dark.scss"

import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import VueRouter from "vue-router"

// @ts-ignore
import Sortable from "vue-sortable"
import BootstrapVue from "bootstrap-vue"
import "@riophae/vue-treeselect/dist/vue-treeselect.css"

// @ts-ignore
import shortkey from "vue-shortkey"
import { formatDateMixin } from "@/mixins/formatDateMixin"
import { calculatedValueDisplay } from "@/mixins/calculatedValueDisplay"
import { filterMixin } from "@/mixins/filtering"
import { utils } from "@/mixins/utils"
import { controls } from "@/mixins/controls"
import { formatFieldsMixin } from "@/mixins/formatFieldsMixin"
import { vSelectOpenUpMixin } from "@/mixins/v-select"

// @ts-ignore
import VueSanitize from "vue-sanitize"
import "bootstrap-vue/dist/bootstrap-vue.css"

import Quill from "quill"
import Placeholder from "@/utils/Placeholder"

// @ts-ignore
import MagicUrl from "quill-magic-url"

Vue.config.productionTip = false

Vue.use(VueRouter)
Vue.use(BootstrapVue, { BModal: { titleTag: "h3" } })
Vue.use(shortkey, { prevent: [".prevent-shortcut"] })
Vue.mixin(formatDateMixin)
Vue.mixin(calculatedValueDisplay)
Vue.mixin(filterMixin)
Vue.mixin(utils)
Vue.mixin(controls)
Vue.mixin(formatFieldsMixin)
Vue.mixin(vSelectOpenUpMixin)
Vue.use(Sortable)

/**
 * Vue Sanitize used for displaying text from rich text areas.
 */
Vue.use(VueSanitize, {
	allowedAttributes: {
		"*": [ "class" ],
		a: [ "href", "rel", "target" ]
	},
	allowedClasses: {
		"*": [	// Quil.css classes.
			"ql-indent-1", "ql-indent-2", "ql-indent-3", "ql-indent-4", "ql-indent-5", "ql-indent-6", "ql-indent-7", "ql-indent-8", "ql-indent-9",
			"ql-video", "ql-align-center", "ql-align-justify", "ql-align-right", "ql-font-serif", "ql-font-monospace", "ql-size-small", "ql-size-large", "ql-size-huge", "ql-direction-rtl",
			"ql-blank", "ql-bg-red", "ql-bg-orange", "ql-bg-yellow", "ql-bg-green", "ql-bg-blue", "ql-bg-purple", "ql-color-white", "ql-color-red", "ql-color-orange", "ql-color-yellow", "ql-color-green", "ql-color-blue", "ql-color-purple"]
	}
})

Vue.config.errorHandler = async function (err) {
	if (typeof window.newrelic !== "undefined" && typeof window.newrelic.noticeError === "function") {
		window.newrelic.noticeError(err)
	}
	// eslint-disable-next-line no-unsafe-finally
	throw err
}

Quill.register("modules/magicUrl", MagicUrl)
Quill.register(Placeholder)

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount("#app")
